import { PROJECT_VARIANTS } from '../../constants';
import * as storyActions from '../../redux/story/storyActions';

const storyActionsMapping = {
  initStory: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.storyInit,
  },
  getSession: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getSession,
  },
  searchSession: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.searchSession,
  },
  getPlatformInfo: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getPlatformInfo,
  },
  uploadStoryMedia: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.uploadStoryMedia,
  },
  searchMediaPool: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.searchMediaPool,
  },
  generateStory: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.generateStory,
  },
  searchGeneratedContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.searchGeneratedContent,
  },
  getUsedMedia: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getUsedMedia,
  },
  changePreview: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.changePreview,
  },
  reGenerateStoryContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.reGenerateStoryContent,
  },
  getMatchedStoryContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.getMatchedStoryContent,
  },
  setStoryContent: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.setStoryContent,
  },
  sendStory: {
    [PROJECT_VARIANTS.ADMIN]: storyActions.sendStory,
  },
};

export default storyActionsMapping;
